import { useEffect } from "react";
import { useModuleBEM } from "@b2bportal/core-themes";
import {
  Dialog,
  DialogContent,
  type DialogProps,
  DialogTrigger,
} from "@b2bportal/core-ui/overridable";
import { trackEvent } from "@hopper-b2b/api";
import { useI18nContext } from "@hopper-b2b/i18n";
import { PriceDropEvents } from "@hopper-b2b/types";
import { ActionLink } from "@hopper-b2b/ui";
import clsx from "clsx";
import styles from "./styles.module.scss";

export interface PriceDropDialogProps extends DialogProps {
  className?: string;
  priceDropAmount?: string;
}

export const PriceDropDialog = ({
  className,
  open,
  onClose,
  onOpen,
  children,
  priceDropAmount,
  ...props
}: PriceDropDialogProps): JSX.Element => {
  const {
    t,
    brand: { urls },
  } = useI18nContext();

  const [block, cn] = useModuleBEM(styles, "PriceDropDialog");

  useEffect(() => {
    if (open) {
      trackEvent({
        eventName: PriceDropEvents.viewed_price_drop_details,
        properties: {},
      });
    }
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose} onOpen={onOpen} {...props}>
      <DialogTrigger>{children}</DialogTrigger>

      <DialogContent
        className={clsx(block, className)}
        title={t("priceDrop.title")}
        bottomFixedContent={
          <button
            className={clsx(cn("cta-button"), "cta-button")}
            onClick={onClose}
          >
            {t("done")}
          </button>
        }
      >
        <p className={cn("subtitle")}>{t("priceDrop.subtitle")}</p>
        <p className={cn("description")}>
          {t("priceDrop.description", {
            travelCreditAmount: priceDropAmount,
          })}
        </p>

        <ActionLink
          onClick={() => window.open(urls.termsAndConditions, "_blank")}
          className={cn("terms-and-conditions-link")}
          content={t("termsAndConditions")}
        ></ActionLink>
      </DialogContent>
    </Dialog>
  );
};
